"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typesBundle = exports.typesAlias = exports.types = exports.rpc = exports.lookupTypes = void 0;
var _typeDefinitions = require("@pendulum-chain/type-definitions");
require("./argument/api");
require("./lookup/types");
var _lookupTypes = _interopRequireWildcard(require("./lookup"));
exports.lookupTypes = _lookupTypes;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// export * from './interfaces/augment-api-mobx';

const types = _typeDefinitions.types;
exports.types = types;
const rpc = _typeDefinitions.rpc;
exports.rpc = rpc;
const typesAlias = _typeDefinitions.typesAlias;
exports.typesAlias = typesAlias;
const typesBundle = _typeDefinitions.typesBundle;
exports.typesBundle = typesBundle;